import { Redirect, Route } from "react-router-dom";
// import NotFound404 from "../pages/NotFound/NotFound404";

const PrivateRoute = ({ component: Component, ...rest }) => {
	const token = localStorage.getItem("token");
	return (
		<Route
			{...rest}
			render={(props) =>
				token ? <Component {...props} /> : <Redirect to="/Signin" />
			}
		/>
	);

	// return (
	//   <Route
	//     {...rest}
	//     render={(props) => {
	//       return <Component {...props} /> ? (
	//         <Component {...props} />
	//       ) : (
	//         <Redirect to="/404" component={NotFound404} />
	//       );
	//     }}
	//   />
	// );
};

export default PrivateRoute;
